import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Added ".js" extension
import { Modal } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { FaStar, FaMapMarkerAlt } from "react-icons/fa";
import { Carousel } from "react-bootstrap";
import '../App.css';

// import Gallery from './Gallery';

const testimonials = [
    {
        name: "Ananya Bachchan",
        location: "Mumbai",
        rating: 4.8,
        review:
            "It was my first experience, I loved it. I booked for my nephew’s baby ceremony. The decoration made it memorable.",
    },
    {
        name: "Ananya Ganguly",
        location: "Mumbai",
        rating: 4.7,
        review:
            "Awesome decor done by them. I booked Annaprashan decoration service. One of the best decorators in Mumbai.",
    },
    {
        name: "Diya Nigam",
        location: "Mumbai",
        rating: 4.9,
        review:
            "Superb Flower decoration. Best in Mumbai. Made my daughter's naming ceremony memorable.",
    },
    {
        name: "Rohan Mehta",
        location: "Mumbai",
        rating: 4.8,
        review:
            "Absolutely stunning work! The birthday decor was exactly as I envisioned. Professional and creative team.",
    },
    {
        name: "Sneha Sharma",
        location: "Mumbai",
        rating: 5.0,
        review:
            "I booked them for my baby shower, and they exceeded my expectations. Beautiful setup and great attention to detail!",
    },
    {
        name: "Vikram Kapoor",
        location: "Mumbai",
        rating: 4.6,
        review:
            "The wedding decor was breathtaking! Thank you for making our special day look magical and elegant.",
    },
    {
        name: "Meera Iyer",
        location: "Mumbai",
        rating: 4.9,
        review:
            "I was amazed by their creativity and dedication. The festive decorations were vibrant and beautiful.",
    },
    {
        name: "Amit Verma",
        location: "Mumbai",
        rating: 4.7,
        review:
            "Excellent service and timely execution. The engagement ceremony looked absolutely gorgeous.",
    },
    {
        name: "Priya Khanna",
        location: "Mumbai",
        rating: 4.9,
        review:
            "Their theme-based decoration for my son’s birthday party was simply amazing! Highly recommended.",
    },
];

const Home = (gallery) => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [show, setShow] = useState(false);

    const handleShow = (image) => {
        setSelectedImage(image);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    const settings1 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768, // Tablet & Mobile
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const decorItems = [
        {
            title: "BirthDay Decoration",
            image: "./images/birthday.webp",
        },
        {
            title: "Bedroom Decoration",
            image: "./bedRoom.webp",
        },
        {
            title: "baby shower",
            image: "./BabyShower.webp",
        },
        {
            title: "Bacchlors Decoration",
            image: "./bachlore.webp",
        },
        {
            title: "Anniversary",
            image: "./Aniversary (1).webp",
        },
        {
            title: "Nail art",
            image: "./nailArt.webp",
        },
        {
            title: "Mundan Decoration",
            image: "./Mundan.webp",
        },
        {
            title: "Tattoo Art",
            image: "./TattoArt.webp",
        },
        {
                    title: "Haldi Mehndi",
            image: "./images/haldi1.webp",
        },
        {
            title: "Welcome baby decoration",
            image: "./wellcomeBaby.webp",
        },
        {
            title: "Game host",
            image: "./gameHost.webp",
        },
        {
            title: "Magic show",
            image: "./m2.webp",
        },
        {
            title: "Naming Ceremony",
            image: "./naming.webp",
        },
        {
            title: "Marathi Baby Shower",
            image: "./marathi.webp",
        },

    ];

    const decorItems1 = [
        { title: "Birthday Decoration", image: "./Birthday.webp" },
        { title: "Kids Decoration", image: "./images/kids-dec.webp" },
        { title: "Newborn Welcome", image: "./images/newborn-dec.webp" },
        { title: "Anniversary", image: "./images/anni-dec.webp" },
        { title: "Baby Shower", image: "./wb10.webp" },
        { title: "First Night", image: "./FirstNight.webp" },
    ];

    const decorItems2 = [
        {
            title: "Balloon Hall Setup",
            image: "./birthSec.webp",

        },
        {
            title: "Elegant Birthday Room Decor",
            image: "./birthSec1.webp",

        },
        {
            title: "Happy Moments Decor",
            image: "./birthSec2.webp",

        },
        {
            title: "Photo Birthday Setup",
            image: "./images/birth4.webp",

        },
    ];

    const anniversaryItems = [
        {
            title: "Candlelight Dinner Setup",
            image: "./images/ani1.webp",

        },
        {
            title: "Romantic Room Decor",
            image: "./images/ani2.webp",

        },
        {
            title: "Heart Balloons Surprise",
            image: "./images/ani3.webp",

        },
        {
            title: "Rose Petals & Lights",
            image: "./images/ani4.webp",

        },
    ];

    const babyDecorationItems = [
        {
            title: "Baby Arrival Balloon Decor",
            image: "./shopping.webp",

        },
        {
            title: "Blue & Pink Theme Setup",
            image: "./images/wb22.webp",

        },
        {
            title: "Newborn Welcome Home Decor",
            image: "./images/wb3.webp",

        },
        {
            title: "Balloon Arch & Cradle Setup",
            image: "./images/wb44.webp",

        },
    ];

    const partyDecorationItems = [
        {
            title: "Glamorous Balloon Setup",
            image: "./bachParty1.webp",

        },
        {
            title: "Rose Gold Theme Party",
            image: "./bachParty2.webp",

        },
        {
            title: "Bride-to-Be Neon Decor",
            image: "./bachParty3.webp",

        },
        {
            title: "Luxury Lounge Bachelorette",
            image: "./bcParty.webp",

        },
    ];

    const carDecorations = [
        {
            image: "./djdecore5.webp",

        },
        {

            image: "./djdecor3.webp",

        },
        {

            image: "./djdecor(1).webp",

        },
        {
            image: "./djdecor4.webp",

        },
    ];

    const themes = [
        {
            title: "Cocomelon Theme",
            image: "./images/bk1.webp",
        },
        {
            title: "Baby Shark Theme",
            image: "./images/bk2.webp",
        },
        {
            title: "Boss Baby Theme",
            image: "./images/bk3.webp",
        },
        {
            title: "Jungle Theme",
            image: "./images/bk4.webp",
        },
        {
            title: "Frozen Theme",
            image: "./images/bk5.webp",
        },
        {
            title: "Mermaid Theme",
            image: "./images/bk6.webp",
        },
    ];

    const marathiBaby = [
        {
            image: "./wc(8).webp",
        },
        {
            image: "./wc(9).webp",
        },
        {
            image: "./wc(13).webp",
        },
        {
            image: "./wc(18).webp",
        }
    ]

    const namingCr = [
        {
            image: "./wb1.webp",
        },
        {
            image: "./a(1).webp",
        },
        {
            image: "./a(9).webp",
        },
        {
            image: "./a(12).webp",
        }
    ]


    return (
        <>
            {/* Corousel section  */}
            <section>
                <div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="./Fun4e.webp" class="d-block w-100 home-ban" alt="Slide 2" />
                        </div>
                        <div class="carousel-item">
                            <img src="./images/ban1.webp" class="d-block w-100 home-ban" alt="Slide 1" />
                        </div>
                        <div class="carousel-item">
                            <img src="./images/ban2.webp" class="d-block w-100 home-ban" alt="Slide 3" />

                        </div>
                        <div class="carousel-item">
                            <img src="./images/ban3.webp" class="d-block w-100 home-ban" alt="Slide 4" />
                        </div>
                        <div class="carousel-item">
                            <img src="./images/ban4.webp" class="d-block w-100 home-ban" alt="Slide 5" />
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </section>

            {/* second Corousel  */}
            <section>
                <div className="container mt-4">
                    <Slider {...settings1}>
                        {decorItems.map((item, index) => (
                            <div key={index} className="p-2">
                                <div className="card border-0 shadow-lg rounded-lg">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded"
                                        style={{ height: "300px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">{item.title}</h5>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered size="xl">
                    <Modal.Body className="p-0">
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <div className="d-flex justify-content-center align-items-center vh-100">
                                <img src={selectedImage} alt="Zoomed In" className="img-fluid w-100 h-100" style={{ objectFit: "contain" }} />
                            </div>
                        )}
                    </Modal.Body>
                </Modal>

            </section>

            {/* Baloon Decoration */}
            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <h2 className="text-center fw-bold">Balloon Decoration</h2>
                    <p className="text-center text-muted">Wide Range of Options</p>
                    <hr className="w-25 mx-auto border-danger" />

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {decorItems1.map((item, index) => (
                            <div key={index} className="col-md-2 col-sm-4 col-6 mb-4">
                                <div className="card border-0 shadow-sm rounded-lg">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded"
                                        style={{ height: "180px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                    <div className="text-center mt-2">
                                        <h6 className="fw-bold">{item.title}</h6>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} >

                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Birthday Decoration</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {decorItems2.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container text-center mt-5 head-sec">
                    {/* Section Heading */}
                    <h2 className="fw-bold">Kids Birthday Decorations</h2>
                    <p className="text-muted">Fun-Filled Themes for Every Celebration!</p>

                    {/* Themes Row */}
                    <div className="d-flex justify-content-center flex-wrap mt-3">
                        {themes.map((theme, index) => (
                            <div key={index} className="text-center mx-3">
                                <a href="/gallery">
                                    <img
                                        src={theme.image}
                                        alt={theme.title}
                                        className="rounded-circle shadow"
                                        style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                    />
                                </a>
                                <p className="mt-2 fw-bold">{theme.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Romantic Anniversary Decoration</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {anniversaryItems.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Welcome Baby Decoration</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {babyDecorationItems.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Naming Ceremony</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {namingCr.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Marathi Baby Shower</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {marathiBaby.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>

            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">Bachelorette Party Decoration</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {partyDecorationItems.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>

            <section>
                <div className="container mt-5">
                    {/* Section Heading */}
                    <div className="d-flex justify-content-between align-items-center head-sec">
                        <h2 className="fw-bold">DJ and Music Decoration</h2>
                        <Link to="/gallery" className="text-danger fw-bold">View All</Link>
                    </div>

                    {/* Grid Section */}
                    <div className="row mt-4">
                        {carDecorations.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="img-fluid rounded-top"
                                        style={{ height: "220px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => handleShow(item.image)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for Full-Screen Zoom */}
                <Modal show={show} onHide={handleClose} centered fullscreen>
                    <Modal.Body
                        className="zoom-modal p-0 d-flex justify-content-center align-items-center"
                        onClick={handleClose} // Click anywhere to close modal
                    >
                        <button
                            onClick={handleClose}
                            className="btn btn-dark position-absolute top-0 end-0 m-3"
                            style={{ zIndex: 10 }}
                        >
                            ✖
                        </button>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Zoomed In"
                                className="zoom-image"
                                onClick={(event) => event.stopPropagation()} // Prevent modal close when clicking the image
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </section>


            <section
                className="testimonial"
                style={{ backgroundImage: "url('./images/banner1.webp')", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}
            >
                <div className="testimonial-container">
                    <h2 className="text-center section-title">Google Reviews</h2>
                    <Carousel indicators={false} controls={true} interval={3000}>
                        {testimonials.map((testimonial, index) => (
                            <Carousel.Item key={index}>
                                <div className="testimonial-card">
                                    <p className="testimonial-text">"{testimonial.review}"</p>
                                    <div className="testimonial-user">
                                        <div className="user-avatar">{testimonial.name.charAt(0)}</div>
                                        <div className="user-info">
                                            <h5>{testimonial.name}</h5>
                                            <p className="location">
                                                <i className="bi bi-geo-alt"></i> {testimonial.location}
                                            </p>
                                            <p className="rating">⭐ {testimonial.rating}</p>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </section>


        </>
    );
};

export default Home;
